import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmailAddress } from 'common/store/genesys-cloud/conversations/emails/models/email-address.model';
import { EmailMessage } from 'common/store/genesys-cloud/conversations/emails/models/email-message.model';
import { getFormattedAddresses } from 'common/emails/email-address-helper';
import * as moment from 'moment';

@Component({
  selector: 'app-genesys-email-viewer',
  templateUrl: './genesys-email-viewer.component.html',
  styleUrls: ['./genesys-email-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailViewerComponent {

  @Input()
  emailMessage: EmailMessage;

  detailsExpanded = false;

  getFormattedTime(dateTime: string): string {
    return moment(dateTime).format('LLL');
  }

  toggleMoreDetails(): void {
    this.detailsExpanded = !this.detailsExpanded;
  }

  getFormattedEmailAddress(emailAddress: EmailAddress): string {
    if (emailAddress.name) {
      return `"${emailAddress.name}" <${emailAddress.email}>`;
    }

    return emailAddress.email;
  }

  getFormattedEmailAddresses(emailAddresses: EmailAddress[]): string {
    return getFormattedAddresses(emailAddresses);
  }

  hasEmailAddress(emailAddresses: EmailAddress[]): boolean {
    return emailAddresses.some(Boolean);
  }
}
